export default "__VITE_ASSET__CfCCuGjT__"